import React from 'react'
import Navbar from '../../components/Public/Navbar'
import Footer from '../../components/Public/Footer'
import Main from './FAQ/Main'

export default function FAQ() {
  return (
    <>
      <Navbar />
      <Main />
      <Footer />
    </>
  )
}
